import { useState } from "react";
import CompanyService, { DataType } from "../../services/CompanyService";
import { TranslationService } from "../../services/TranslationService";
import { TableHeader, TableHeaderWithFieldId } from "../shared/Table";
import TableContext from "../task/TableContext";
import InboxListContext from "./InboxListContext";

import { InboxTableTableColumn } from "./InboxTableTableColumn";
import { QuickFilterType } from "./InboxTableProvider";

export function getInboxTableHeaders(quickfilter: number) {
  const whatsappFields: TableHeaderWithFieldId[] = [
    {
      ...new TableHeader("check", "", false, false, "w-40px"),
      fieldId: "check",
      type: DataType.YesNo
    },
    {
      ...new TableHeader(
        "collector",
        TranslationService.translate.Collector || "Cobrador",
        false,
        false,
        "th-w-120"
      ),
      fieldId: "CollectorName",
      type: DataType.Text
    },
    {
      ...new TableHeader(
        "personName",
        TranslationService.translate.Client,
        false,
        false,
        "th-w-120"
      ),
      fieldId: "personName",
      type: DataType.Text
    },
    {
      ...new TableHeader(
        "content",
        TranslationService.translate.LastMessage || "Último mensaje",
        false,
        false,
        "inbox-content-column"
      ),
      fieldId: "Content",
      type: DataType.Text
    },
    {
      ...new TableHeader(
        "date",
        TranslationService.translate.Date,
        false,
        false,
        "th-w-120"
      ),
      fieldId: "date",
      type: DataType.Date
    },
    {
      ...new TableHeader(
        "lastdate",
        TranslationService.translate.LastMessageDate,
        false,
        false,
        "w-200px"
      ),
      fieldId: "LastActivityDate",
      type: DataType.Date
    }
  ];

  const emailFields: TableHeaderWithFieldId[] = [
    {
      ...new TableHeader(
        "fromName",
        TranslationService.translate.Sender,
        false,
        false,
        "th-w-120"
      ),
      fieldId: "FromName",
      type: DataType.Text
    },
    {
      ...new TableHeader(
        "personName",
        TranslationService.translate.Client,
        false,
        false,
        "th-w-120"
      ),
      fieldId: "personName",
      type: DataType.Text
    },
    {
      ...new TableHeader(
        "subject",
        TranslationService.translate.Subject,
        false,
        false,
        "inbox-subject-column"
      ),
      fieldId: "Subject",
      type: DataType.Text
    },
    {
      ...new TableHeader(
        "date",
        TranslationService.translate.Date,
        false,
        false,
        "th-w-120"
      ),
      fieldId: "date",
      type: DataType.Date
    },
    {
      ...new TableHeader("actions", "", false, false, "w-100px"),
      fieldId: "actions",
      type: DataType.Text
    }
  ];

  return quickfilter === QuickFilterType.Whatsapp
    ? whatsappFields
    : emailFields;
}

export const InboxTableItem = (
  onCheckboxChange?: (messageId: number, checked: boolean) => void,
  headers?: TableHeaderWithFieldId[]
) =>
  function InvoiceTableItemImpl({ data }: { data: any }) {
    const [loadingData, setLoadingData] = useState(false);

    return (
      <InboxListContext.Consumer>
        {({ messageIds, messageAll }) => (
          <TableContext.Consumer>
            {() => (
              <tr
                key={data.ID}
                style={{ cursor: "pointer" }}
                className="pointer show-child-on-hover"
              >
                {onCheckboxChange && (
                  <td className="" onClick={(event) => event.stopPropagation()}>
                    <input
                      type="checkbox"
                      className="checkbox-inbox"
                      data-invoiceselected={data.ID}
                      disabled={!CompanyService.canActOnMessage()}
                      defaultChecked={
                        messageAll || messageIds.includes(data.ID)
                      }
                      onChange={(event) =>
                        onCheckboxChange(
                          data.ID,
                          (event.target as HTMLInputElement).checked
                        )
                      }
                    />
                  </td>
                )}
                {headers
                  ?.filter((x) => x.fieldId !== "checkbox")
                  .map((header) => (
                    <InboxTableTableColumn
                      key={header.fieldId}
                      data={data}
                      header={header}
                      loadingData={loadingData}
                      setLoadingData={setLoadingData}
                    />
                  ))}
              </tr>
            )}
          </TableContext.Consumer>
        )}
      </InboxListContext.Consumer>
    );
  };
